export const SimpleMarkdown = (markdown) => {
  if (!markdown) return <div className="text-gray-500">-</div>

  const sanitizedMarkdown = markdown.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
  const lines = sanitizedMarkdown.split('\n')

  return (
    <div className="space-y-2 bg-white">
      {lines.map((line, index) => (
        <div key={index} className="text-sm">
          {line}
        </div>
      ))}
    </div>
  )
}